import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { CountryItem } from "../../models/country-item.model";
import { LookupService } from "../../services/lookup.service";

@Component({
    selector: 'country-selector',
    templateUrl: 'country-selector.component.html',
    styleUrls: ['country-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
  export class CountrySelectorComponent {
    @Input() parentFormGroup: FormGroup;
    @Input() controlName: string;
    @Input() placeholderText: string;

    readonly countries$: Observable<CountryItem[]>;

    constructor(lookupService: LookupService) {
        this.countries$ = lookupService.getCountries();
    }
  }
